// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\ActionTrackingResponse

import { hydratePerson, type Person, type PersonApiResponse } from './person.gen';
import { hydrateActionTrackingEntity, type ActionTrackingEntity, type ActionTrackingEntityApiResponse } from './actionTrackingEntity.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type ActionTrackingApiResponse = {
	id: number;
	event: string;
	transactionId: string;
	createdAt: string;
	data: Record<string, string>;
	actorType: string;
	actorId: string | null;
	entityType: string;
	entityId: string;
	actor: PersonApiResponse | null;
	entity: ActionTrackingEntityApiResponse | null;
};

export type ActionTracking = {
	id: number;
	event: string;
	transactionId: string;
	createdAt: DateTime;
	data: Record<string, string>;
	actorType: string;
	actorId: string | null;
	entityType: string;
	entityId: string;
	actor: Person | null;
	entity: ActionTrackingEntity | null;
};

export function hydrateActionTracking(data: ActionTrackingApiResponse): ActionTracking {
	return {
		...data,
		createdAt: DateTimefromISO(data.createdAt)!,
		data: Array.isArray(data.data) ? {} : data.data,
		actor: data.actor ? hydratePerson(data.actor) : null,
		entity: data.entity ? hydrateActionTrackingEntity(data.entity) : null,
	};
}